import { Link, useLocation } from "react-router-dom";
import { MENU_ITEMS } from "@/constants/menu";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <nav className={styles.navContainer}>
      <div className="container">
        <ul className={styles.navItems}>
          {MENU_ITEMS.map((menu, index) => (
            <li
              key={index}
              className={`${styles.navItem} ${
                menu.displayName === "Centre d'aide et FAQ"
                  ? styles.navItemRight
                  : ""
              }`}
            >
              <Link
                to={menu.link}
                className={`${styles.navLink} ${
                  pathname === menu.link ? styles.navLinkActive : ""
                }`}
              >
                {menu.displayName}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
